export { sendEvent } from 'next-flight-server-reference-proxy-loader?id=7f51fb5bf03b214fb6ecbbe6c528cffa4830468077&name=sendEvent!'